module.exports = __webpack_public_path__ + "static/img/free-bg.2bf05cb1.png";